import { Component, Inject, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AppSettings } from 'src/app/core/common/app-settings';
import { OperacionEnum } from 'src/app/core/enums/operacion.enum';
import { GrupoSocioService } from 'src/app/core/services/caso/grupo-socio.service';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { GrupoSocioDto } from 'src/app/shared/models/caso/grupo/grupo-socio/grupo-socio-dto.model';
import { SocioVo } from 'src/app/shared/models/caso/socio/socio-vo.model';

@Component({
  selector: 'vex-grupo-socio-form',
  templateUrl: './grupo-socio-form.component.html',
  styleUrls: ['./grupo-socio-form.component.scss']
})
export class GrupoSocioFormComponent implements OnInit {

  appSettings = AppSettings;
  form: FormGroup;
  grupoSocioService = inject(GrupoSocioService);
  public operation: OperacionEnum;
  dto: GrupoSocioDto = new GrupoSocioDto();
  idGrupo: number;

  socios: SocioVo[];

  constructor(private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    private toastrService: ToastrService) {
    this.operation = data.operation;
    this.idGrupo = data.entity;
    this.form = this.fb.group({
      idSocio: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.grupoSocioService.findAllAvailables(this.idGrupo).subscribe(response => this.socios = response.data);
  }

  save() {
    this.dto.idSocio = this.form.value.idSocio;
    switch (this.operation) {
      case OperacionEnum.create:
        this.grupoSocioService.persist(this.idGrupo, this.dto).subscribe(
          (result) => {
            if (result.status) {
              this.toastrService.success(result.message);
              this.dialogRef.close(true);
            } else
              this.toastrService.warning(result.message);

          },
          (error) => {
            this.toastrService.error(error.message);
          }
        );
        break;
    }
  }

}
